import React from "react";
import { Controller } from "react-hook-form";
import { Input, Label } from "reactstrap";
import ValidationMsgComponent from "../ValidationMsgComponent";

interface ControlledCheckBoxFieldProps {
  label?: string;
  inputName: string;
  placeholder?: string;
  invalid?: any;
  control?: any;
  errors?: any;
  rules?: any;
  isDisabled?: boolean;
}

/**
 * Component -> Controlled CheckBox Field
 * @param label Input name for label
 * @param inputName input field name
 * @param placeholder placeholder for the input field
 * @param invalid whether input contain validation errors (boolean)
 * @param control control object of react-hook-form
 * @param errors validation errors object of react-hook-form
 * @param rules validation rules
 * @returns
 */

const ControlledCheckBoxField: React.FC<ControlledCheckBoxFieldProps> = ({
  label,
  inputName,
  placeholder,
  invalid,
  control,
  errors,
  rules,
  isDisabled,
}) => {
  return (
    <>
      <div className="form-check">
        <Controller
          name={inputName}
          control={control}
          rules={rules}
          render={({ field }) => (
            <Input
              id={inputName}
              type="checkbox"
              placeholder={placeholder}
              invalid={invalid}
              disabled={isDisabled}
              checked={Boolean(field.value)}
              onChange={(e) => field.onChange(e.target.checked)}
              onBlur={field.onBlur}
              innerRef={field.ref}
            />
          )}
        />
        <Label className="form-label" htmlFor={inputName}>
          {label}
        </Label>
      </div>
      {invalid && (
        <ValidationMsgComponent
          inputName={inputName}
          invalid={invalid}
          errors={errors}
          rules={rules}
        />
      )}
    </>
  );
};

export default ControlledCheckBoxField;
